module.exports = __webpack_public_path__ + "img/shopee.e07f252b.jpg";